import React, { ReactElement } from 'react'
import { Box, Text } from '@mindfulchefuk/design-system'

type TRecipeBeforeYouStart = {
  beforeYouStart: string
}

export const RecipeBeforeYouStart = ({
  beforeYouStart,
}: TRecipeBeforeYouStart): ReactElement => {
  return (
    <Box backgroundColor="salt" padding={20} mb={16}>
      <Text variant="body-lg-500" mb={8} data-testid="before-you-start-title">
        Before you start
      </Text>
      <Text
        variant="body-lg"
        as="li"
        listStyleType="disc"
        ml={20}
        data-testid="before-you-start"
      >
        {beforeYouStart}
      </Text>
    </Box>
  )
}
